import React from "react";
import classNames from "classnames";
import * as styles from "./Image.module.scss";

interface ImageProps {
	src: string;
	alt?: string;
	className?: string;
	width?: number | string;
	height?: number | string;
	fill?: boolean; // аналог next/image fill
	noLazy?: boolean; // новый проп для отключения lazy
}

const Image: React.FC<ImageProps> = ({
	src,
	alt = "",
	className,
	width,
	height,
	fill = false,
	noLazy = false,
}) => {
	const webpSrc = src.replace(/\.(png|jpg|jpeg)$/, ".webp");

	const pictureClass = classNames({ [styles.pictureFill]: fill }) || undefined;
	const imgClass =
		classNames(className, { [styles.imgFill]: fill }) || undefined;

	return (
		<div className={pictureClass}>

			<img
				src={src}
				alt={alt}
				className={imgClass}
				width={fill ? undefined : width}
				height={fill ? undefined : height}
				{...(!noLazy && { loading: "lazy" })}
			/>
		</div>
	);
};

export default Image;
